import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import Header from "../Header";
import Menu from "../Menu";
import { SURGEON } from "../../services/Surgeon";
import "../../assets/css/patient-symptom.css";
import "../../assets/css/custom.css";

import { CONFIG, URLS, checkAuth, getLoggedInData,sentenceCase} from "../../helpers/Common";
import $ from "jquery";

class SurgeonPatientNarrative extends Component {

    selectedLocation=[];
    allComplains=[];

    constructor(props) {
        super(props);
        if(this.props.location.state)
        {
            this.selectedLocation=this.props.location.state.patientData.complainLocationData;
            this.allComplains=JSON.parse(this.props.location.state.patientData.all_complaints);
            localStorage.setItem("newData",JSON.stringify(this.props.location.state.patientData.new_data));
            // console.log('All complain here',this.allComplains)
        }
        else
        {
            this.setState({redirect: true});
        }
       

        // const { history } = this.props;
        // const { location } = history;
        // const { state } = location;
        // const { patientData } = state;
        // const {complainLocationData} = patientData;


        this.state = {
            narrativeSummary: "",
            first_name: "",
            last_name: "",
            id: "",
            title: "",
            dob: '',
            patientId: '',
            surgeon_id:'',
            allComplains:[],
            status:0,imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
            getComplainLocationData:this.selectedLocation,
            narrativeData: new Array(),
            additionalInfoByPatient:""
        };
        this.handleUpdateAction = this.handleUpdateAction.bind(this);
        this.deleteInfo         = this.deleteInfo.bind(this);
        this.getLoggedInData  = getLoggedInData.bind(this)// Import from common
        this.checkAuth        = checkAuth.bind(this)// Import from common
    }

    componentWillMount() {

        // this.setState({...this.state,allComplains:this.props.getAllComplains});


        checkAuth();
        let userData = getLoggedInData();
        this.setState({
            userData: userData,
            surgeon_id: userData.user_id,
            allComplains:this.allComplains
        });
        let id  = this.props.location.pathname.split('/');
        id      = id[(id.length)-1];
        this.setState({
            patientId:id
        })
        SURGEON.getAdditionalPatientNarrative(id).then().then(res => {
            if(res.data.header.error==0)
            {   
                let narrativeData      = res.data.body.details;
                console.log('PAI here ',narrativeData)

                this.setState({
                    narrativeData: narrativeData,
                    isLoading: false,
                });
                
            }
        }).catch(err => {
        return err;
        });
        try {
            let narrative_summary = this.props.location.state.patientData.narrative_summary;
            let additionalInfoByPatient = this.props.location.state.patientData.patient_additional_info;
            narrative_summary = narrative_summary.replace("<br><br><br><br><br><br>", "<br><br><br>");
            this.setState({
                narrativeSummary: narrative_summary,
                additionalInfoByPatient:additionalInfoByPatient,
                // first_name: this.props.location.state.patientData.first_name,
                // last_name: this.props.location.state.patientData.last_name,
                // id: this.props.location.state.patientData.id,
                // title: this.props.location.state.patientData.title,
                // dob: this.props.location.state.patientData.date_of_birth,
                // gender: this.props.location.state.patientData.gender.toLowerCase(),
                 status: this.props.location.state.patientData.status
            });
           
        } catch (e) {
            this.props.history.push('/surgeon/patients/');
        }
    }

    handleAction = e => {

        $(".marker").remove();

        SURGEON.approvedPatientNarrative(this.state.patientId).then(res => {
            if(res.data.header.error==0)
            {
                this.props.history.push('/surgeon/patients/');
            }
            else
            {
                alert("There was an error ");
            }
            
        }).catch(err => {
            alert("There was an error ");
            this.setState({redirect: true});
        });
    };

    handleUpdateAction = (e) => {

        $(".marker").remove();

        this.props.history.push({
            pathname: '/surgeon/patient/complain/'+this.state.patientId,
            state: { narrative_id:  this.props.location.state.patientData.id,patientData:this.props.location.state.patientData},
        });
    }
    deleteInfo = (e) => {
        let id                  = e.target.dataset.id;
        let additional_response = e.target.dataset.response;
        let deleteRecords = window.confirm("Are you sure want to delete this additional info?"); 
        if(deleteRecords == true)
        {
            SURGEON.deleteAdditionalInfo(id,additional_response).then(res => {
                if(res.data.header.error==0)
                {   
                    
                    var additional_response = this.state.narrativeData;
                    let udpdatadNarrativeData = new Array();
                    Object.values(additional_response).forEach(function(row, _key) 
                    {
                        if(row.id != id && row.additional_response!=additional_response)
                        {
                            udpdatadNarrativeData.push(row);
                        }
                    });
                    this.setState({
                        narrativeData: udpdatadNarrativeData
                    })
                }
                else
                {
                    alert("There was an error ");
                }
                
            }).catch(err => {
                alert("There was an error ");
            });
        }
    };

    markPosition=()=>{

        if(this.state.getComplainLocationData.selectedLocation === undefined || this.state.getComplainLocationData.selectedLocation.length == 0){

        }else{

            this.state.getComplainLocationData.selectedLocation.map((item)=>{

                if(item.picCoordinates === undefined){

                    const picCoordinates = document.getElementById('pic').getBoundingClientRect();

                    this.mark(item.id,picCoordinates,item.coordinate_y,item.coordinate_x);

                }else{

                    this.mark(item.id,item.picCoordinates,item.coordinate_y,item.coordinate_x);

                }

            });

        }

    };

    markPosition=()=>{

        if(this.state.getComplainLocationData.selectedLocation === undefined || this.state.getComplainLocationData.selectedLocation.length == 0){

        }else{

            this.state.getComplainLocationData.selectedLocation.map((item)=>{

                if(item.picCoordinates === undefined){

                    var picCoordinates = document.getElementById('pic').getBoundingClientRect();

                    this.mark(item.id,picCoordinates,item.coordinate_y,item.coordinate_x);

                }else{

                    this.mark(item.id,item.picCoordinates,item.coordinate_y,item.coordinate_x);

                }

            });

        }

    };

    markPositionForLoop=(selectedLocations,makerKey)=>{

        if(selectedLocations === undefined || selectedLocations.length == 0){

        }else{

            selectedLocations.map((item)=>{

                if(item.picCoordinates === undefined){

                    var picCoordinates = document.getElementById('pic').getBoundingClientRect();

                    this.mark(item.id,picCoordinates,item.coordinate_y,item.coordinate_x,makerKey);

                }else{

                    this.mark(item.id,item.picCoordinates,item.coordinate_y,item.coordinate_x,makerKey);

                }

            });

        }

    };

    mark=(markerId, picCoordinates, top, left)=>{
        let markerRadius = 13;
        // $(".marker").remove();
        $(".male-img").append(
            $('<div class="marker marker'+ markerId + '"></div>').css({
                position: "absolute",
                top: `calc(${top}px - (${markerRadius}px / 2))`,
                left: `calc(${left}px - (${markerRadius}px / 2))`,
                width: markerRadius + 'px',
                height: markerRadius + 'px',
                backgroundColor: "#990000",
                borderRadius: '50%',
                display: 'inline-block',
            })
        );
    }

    mark=(markerId, picCoordinates, top, left,markerKey)=>{
        let markerRadius = 13;
        $(`.male-img${markerKey}`).append(
            $('<div class="marker marker'+ markerId + '"></div>').css({
                position: "absolute",
                top: `calc(${top}px - (${markerRadius}px / 2))`,
                left: `calc(${left}px - (${markerRadius}px / 2))`,
                width: markerRadius + 'px',
                height: markerRadius + 'px',
                backgroundColor: "#990000",
                borderRadius: '50%',
                display: 'inline-block',
            })
        );
    }

    render() {
        console.log('all complains here ',this.allComplains)
        var additionalInfo = "";
        
        return (
            <React.Fragment>
                <Header
                    title="Patient Symptoms Narrative"
                    titleImage="ic-medical-result.png"
                />
                <Menu />

                <section className="patient-symptom">
                    <div className="container">
                        <div className="patient-txt">
                            {/*<div className="male-model-complain">*/}
                            {/*    <div className="container">*/}
                            {/*        <div className="male-img">*/}
                            {/*            <img id="pic" src={ this.state.imgPath+this.state.getComplainLocationData.image} alt=""/>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="narrative-img">
                                        <img
                                            src={require("../../assets/img/icons/female-doctor.png")}
                                            alt=""
                                        />
                                        <h2 className="img-title">{CONFIG.Original_Narrative}</h2>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="list-wrapper">
                                    { this.allComplains.map((item,key)=>{
                                        
                                        if (this.allComplains[this.allComplains.length-1] ) {
                                            if (this.props.location.state.patientData.patient_additional_info) {
                                                additionalInfo = <div> <h6>Additional Information:</h6>{ReactHtmlParser(this.props.location.state.patientData.patient_additional_info)}</div>;
                                                
                                            }
                                        }

                                        setTimeout(()=>{
                                            this.markPositionForLoop(item.image_and_points[item.image_and_points.length-1].complainLocationData.selectedLocation,key)
                                        },1000);

                                        return(
                                                <div className="male-model-complain bg-white">
                                                    <div className="txt-content">
                                                        { key === 0 ? ReactHtmlParser(`${this.allComplains[this.allComplains.length-1].profileSummary}`) : null }
                                                    </div>
                                                    <h2 style={{ fontSize:18,paddingLeft:30 }} className="img-title">{ item.image_and_points[item.image_and_points.length-1].complain_type_name } </h2>
                                                    <div className="container" style={{  background : 'white' }}>
                                                        <div className={`male-img male-img${key}`}>
                                                            <img id="pic" src={ this.state.imgPath+item.image_and_points[item.image_and_points.length-1].complainLocationData.image} alt=""/>
                                                        </div>
                                                    </div>
                                                    <div className="txt-content" >
                                                        {ReactHtmlParser(sentenceCase(item.myNarrativeData))}
                                                        
                                                    </div>
                                                </div>
                                        // item.narrativeSummary style={{ overflow:'unset' }}
                                        )
                                        
                                    })}
                                    <div className="txt-content">{additionalInfo}</div>
                                    {
                                        this.state.status==0 &&
                                        <div className="sec-btn patient--btn">
                                            <Link to="#" className="btn-img" onClick={this.handleUpdateAction} >
                                                <img
                                                    src={require("../../assets/img/icons/ic-incomplete-native.png")}
                                                    alt=""
                                                />
                                                <span>{CONFIG.Incomplete_Narrative}</span>
                                            </Link>

                                            <Link to="#" className="btn-img" onClick={this.handleAction}>
                                                <img
                                                    src={require("../../assets/img/icons/ic-complete-native.png")}
                                                    alt=""
                                                />
                                                <span>{CONFIG.Accept_Narrative}</span>
                                            </Link>

                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </section>
                <div className="row">
                    <div className="col-md-3" />
                    <div className="col-md-9">

                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default SurgeonPatientNarrative;
